import { overlay as overlayClassName } from './HiveOverlay.sty.js';
import { HoneycombToolbar } from './toolbar/HoneycombToolbar.js';
import { HoneycombOverlayTooltip } from './tooltip/HoneycombOverlayTooltip.js';
import { Flex } from '../../../layouts/flex/Flex.js';
import { useGraphSize } from '../../core/components/chart-layout/hooks/useGraphSize.js';
import { useTooltipData } from '../../core/components/overlay-tooltip/_to-be-removed/utils.js';
import { useOverlay } from '../../core/components/overlay-tooltip/contexts/OverlayContext.js';
import { useSeriesActions } from '../../core/components/series-action/ChartSeriesActionContext.js';
import { isToolbarEnabled } from '../../core/utils/is-toolbar-enabled.js';
import { HoneycombOverlayRefContext } from '../contexts/HoneycombOverlayRefContext.js';
import { useHoneycombToolbarConfig } from '../hooks/use-honeycomb-toolbar-config.js';
import { useOverlayEvents } from '../hooks/use-overlay-events.js';

export const HiveOverlay = () => {
  const toolbarConfig = useHoneycombToolbarConfig();
  const toolbarEnabled = isToolbarEnabled(toolbarConfig);
  const overlay = useOverlay();
  const {
    handlePointerEnter,
    handlePointerMove,
    handlePointerLeave,
    handleMouseClick,
  } = useOverlayEvents(overlay);
  const { height, width } = useGraphSize();
  const { chartSeriesActions } = useSeriesActions();
  const data = useTooltipData().data;

  const series = data?.series?.[0];
  const metadata = data?.metadata as { id: string } | undefined;

  return (
    <HoneycombOverlayRefContext.Provider value={overlay.overlayRef}>
      <Flex
        className={overlayClassName}
        style={{
          height,
          width,
        }}
        data-testid="honeycomb-overlay"
        onPointerEnter={handlePointerEnter}
        onPointerMove={handlePointerMove}
        onPointerLeave={handlePointerLeave}
        onClick={handleMouseClick}
        ref={overlay.overlayRef}
      >
        <HoneycombOverlayTooltip
          actionsForItem={
            chartSeriesActions && series && metadata
              ? () => () =>
                  chartSeriesActions({
                    id: metadata.id,
                    name: series.name,
                    values: [series.value],
                  })
              : undefined
          }
        />
        {toolbarEnabled && <HoneycombToolbar />}
      </Flex>
    </HoneycombOverlayRefContext.Provider>
  );
};
